import styled from "styled-components"

const StyledStrategyAnimation = styled.div`
  display: flex;
  position: relative;
  height: 720px;
  overflow: hidden;
  .animation-right-text {
    position: absolute;
    transform: translateY(-50%);
    z-index: 2;
    top: 50%;
    left: 50%;
    font-size: 66px;
    line-height: 85px;
    color: #fff;
    cursor: pointer;
  }
  .animation-button-placeholder {
    min-width: 284px;
    position: absolute;
    transform: translateX(-50%);
    z-index: 5;
    bottom: 37px;
    left: 50%;
    padding: 14px 30px;
    border-color: #00fb6e;
    background-color: #00fb6e;
    span {
      color: #000;
    }
    &::before,
    &::after {
      display: none;
    }
    &:hover {
      background-color: #000;
      border-color: #000 !important;
      span {
        color: #fff !important;
      }
    }
  }
  .animation-slider {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 50%;
    cursor: pointer;
    &.left {
      left: 0;
      z-index: 3;
      transition: 0.2s;
      .animation-column {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
      }
    }
    &.right {
      right: 0;
      z-index: 1;
      transition: 0.2s;
    }
    .animation-column {
      transition: 0.2s;
    }
    .animation-slide {
      height: 720px;
      position: relative;
      &__inner {
        position: absolute;
        z-index: 1;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        display: flex;
        transition: 0.2s;
        align-items: center;
        justify-content: center;
        background-color: rgba(0, 0, 0, 0.2);
        border: 3px solid transparent;
      }
      &__animate-text {
        z-index: 20;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 0;
        font-size: 66px;
        line-height: 85px;
        color: #fff;
      }
      &__content {
        max-width: 615px;
        padding: 10px;
        text-align: center;
        display: none;
        .title {
          font-size: 66px;
          line-height: 85px;
          margin-bottom: 23px;
          color: #000;
        }
        .desc {
          margin-bottom: 23px;
        }
      }
    }
  }
  &.active {
    .animation-button-placeholder {
      display: none;
    }
    .animation-slider {
      &.left {
        width: 100%;
        .animation-column {
          height: 720px;
        }
        .animation-slide {
          transition: 0.2s;
          height: 25%;
          &__animate-text {
            font-size: 60px;
            line-height: 80px;
          }
          ${({ slide }) => animate(slide)}
        }
      }
      &.right {
        opacity: 0;
      }
    }
  }
  @media screen and (max-width: 1400px) {
    height: 440px;
    .animation-button-placeholder {
      min-width: 250px;
      bottom: 26px;
    }
    .animation-right-text {
      font-size: 48px;
      line-height: 61px;
    }
    .animation-slider {
      .animation-slide {
        height: 440px;
        &__animate-text {
          font-size: 48px;
          line-height: 61px;
        }
        &__content {
          .title {
            font-size: 48px;
            line-height: 61px;
          }
        }
      }
    }
    &.active {
      .animation-slider {
        &.left {
          .animation-column {
            height: 440px;
          }
          .animation-slide {
            &__animate-text {
              font-size: 40px;
              line-height: 52px;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 750px) {
    height: 520px;
    .animation-right-text {
      font-size: 32px;
      line-height: 43px;
    }
    .animation-slider {
      .animation-slide {
        height: 520px;
        &__animate-text {
          font-size: 32px;
          line-height: 43px;
        }
        &__content {
          .title {
            font-size: 32px;
            line-height: 43px;
          }
        }
      }
    }
    &.active {
      .animation-slider {
        &.left {
          .animation-column {
            height: 520px;
          }
          .animation-slide {
            &__animate-text {
              font-size: 32px;
              line-height: 43px;
            }
          }
        }
      }
    }
  }
`

export default StyledStrategyAnimation

const animate = slide => {
  switch (slide) {
    case 0:
      return `
        &.create{
          ${active_styles}
        }
        &.live,&.think,&.act{
          ${rest_styles}
        }
        &.act{
          transform: scaleX(0.85);
        }
        &.live{
          transform: scaleX(0.90);
        }
        &.think{
          transform: scaleX(0.95);
        }
      `
    case 1:
      return `
          &.think{
            ${active_styles}
          }
          &.live,&.create,&.act{
            ${rest_styles}
          }
          &.act{
            transform: scaleX(0.90);
          }
          &.live{
            transform: scaleX(0.95);
          }
          &.create{
            transform: scaleX(0.95);
          }
        `
    case 2:
      return `
        &.live{
          ${active_styles}
        }
        &.think,&.create,&.act{
          ${rest_styles}
        }
        &.act{
          transform: scaleX(0.95);
        }
        &.think{
          transform: scaleX(0.95);
        }
        &.create{
          transform: scaleX(0.90);
        }
      `
    case 3:
      return `
      &.act{
        ${active_styles}
      }
      &.think,&.create,&.live{
        ${rest_styles}
      }
      &.live{
        transform: scaleX(0.95);
      }
      &.think{
        transform: scaleX(0.90);
      }
      &.create{
        transform: scaleX(0.85);
      }
    `
    default:
      return ``
  }
}

const active_styles = `    
  height: 58%;
  .animation-slide{
    &__inner{
      background-color: #fff;
      border-color: #000;
    }
    &__animate-text{
      display: none;
    }
    &__content{
      display: block;
    }
  }
`
const rest_styles = `    
  height: 14%;
  cursor: pointer;
  .animation-slide{
    &__animate-text{
      right: 50%;
      transform: translate(50%, -50%);
    }
  }
`
